// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoadingScreen from './components/LoadingScreen';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Header from './components/Header';
import { farmBackground, farmLogo } from './assets';
import Products from './pages/Products/Products';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <Router>
      <LoadingScreen images={[farmLogo, farmBackground]}>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products" element={<Products />} />
        </Routes>
        <Footer />
      </LoadingScreen>
    </Router>
  );
};

export default App;
